import script from "./couponPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./couponPrice.vue?vue&type=script&setup=true&lang=js"

import "./couponPrice.vue?vue&type=style&index=0&id=e04134b2&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e04134b2"]])

export default __exports__